var render, staticRenderFns
import script from "./StorePage.vue?vue&type=script&lang=ts&"
export * from "./StorePage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "StorePage.vue"
export default component.exports